import axios from "axios";

const fetch = () => axios.get(`/personal/api/v1/profile/details`);

const save = (data) => axios.put(`/personal/api/v1/profile`, data);

const setPassword = (pwd, old_pwd) => axios.put(`/personal/api/v1/profile/set_password`, { password: pwd, old_password: old_pwd });

const getApps = () => axios.get(`/personal/api/v1/profile/apps`);

const sessions = () => axios.get(`/personal/api/v1/profile/sessions`);

const getSessionApps = sid => axios.get(`/personal/api/v1/sessions/${sid}/apps`);

const setUserLang = (lang) => axios.put(`/personal/api/v1/profile/set_lang`, { lang: lang });

const savePhone = (phone) => axios.put(`/personal/api/v1/profile/save_phone`, { phone: phone });

const removePhone = () => axios.put(`/personal/api/v1/profile/remove_phone`);

const getLastLogins = query => axios.get("/personal/api/v1/lastlogins", {
    headers: {
        ["X-Query"]: JSON.stringify(query),
    }
});

export default {
  fetch,
  save,
  setPassword,
  getApps,
  sessions,
  getSessionApps,
  setUserLang,
  savePhone,
  getLastLogins,
  removePhone
};
